import { accessToken } from '~/features/tokenHandling/accessToken';

/**
 * Endpoints that send a multipart/form-data body. For these, we must NOT set
 * `Content-Type`: the browser has to set `multipart/form-data` together with
 * the correct boundary itself. Forcing `application/json` breaks the upload
 * (the server rejects the multipart body, e.g. with 403/parse errors).
 *
 * RTK Query's `prepareHeaders` (v1.9) does not expose the request body, but it
 * does expose the `endpoint` name, so we gate on that.
 */
const MULTIPART_ENDPOINTS = new Set<string>(['uploadFile']);

export const prepareHeaders = (
    headers: Headers,
    { endpoint }: { endpoint?: string } = {},
) => {
    const token = accessToken.getAccessToken();
    if (token) {
        headers.set('authorization', `Bearer ${token}`);
        if (!endpoint || !MULTIPART_ENDPOINTS.has(endpoint)) {
            headers.set('Content-Type', 'application/json');
        }
    }
    return headers;
};
